import styles from "./RoleProvisioning.module.css";

/**
 * Shown wherever the roles are visible while `account_owner` is the selection
 * (migration-plan.md §4.5). The wildcard is the one role this tool can grant
 * that widens over time, so the warning stays on screen from pick to apply.
 */
export function OwnerWarning() {
  return (
    <div className={`${styles.banner} ${styles.bannerError}`} role="alert">
      <strong>You are granting Account Owner.</strong> This role carries a wildcard: full access to
      every current and future feature of the organisation, including user management. Owners are
      granted only to users who already have an account and a membership; emails without an account
      are skipped, and users in more than one organisation are skipped as usual.
    </div>
  );
}
